import type { CatalogIndex } from "./productCatalog";
import { getCatalogEntry, getEffectivePrice } from "./productCatalog";

export type CartLineForTotals = {
  productUuid: string;
  quantity: number;
  invalid?: boolean;
};

function isBillableCartLine(item: CartLineForTotals): boolean {
  return item.invalid !== true;
}

export function sumCartProductsTotal(
  cartItems: CartLineForTotals[],
  catalogIndex: CatalogIndex,
  at: Date = new Date()
): number {
  return cartItems.reduce((total, cartItem) => {
    if (!isBillableCartLine(cartItem) || !cartItem.productUuid) {
      return total;
    }
    const entry = getCatalogEntry(catalogIndex, cartItem.productUuid);
    if (!entry) {
      return total;
    }
    const { price } = getEffectivePrice(entry, at);
    return total + price * cartItem.quantity;
  }, 0);
}

export function sumCartProductsRegular(
  cartItems: CartLineForTotals[],
  catalogIndex: CatalogIndex,
  at: Date = new Date()
): number {
  return cartItems.reduce((total, cartItem) => {
    if (!isBillableCartLine(cartItem) || !cartItem.productUuid) {
      return total;
    }
    const entry = getCatalogEntry(catalogIndex, cartItem.productUuid);
    if (!entry) {
      return total;
    }
    const { priceRegular } = getEffectivePrice(entry, at);
    return total + priceRegular * cartItem.quantity;
  }, 0);
}

export function sumCartDiscount(
  cartItems: CartLineForTotals[],
  catalogIndex: CatalogIndex,
  at: Date = new Date()
): number {
  return cartItems.reduce((total, cartItem) => {
    if (!isBillableCartLine(cartItem) || !cartItem.productUuid) {
      return total;
    }
    const entry = getCatalogEntry(catalogIndex, cartItem.productUuid);
    if (!entry) {
      return total;
    }
    const { adjustmentAmount } = getEffectivePrice(entry, at);
    return total + adjustmentAmount * cartItem.quantity;
  }, 0);
}

/** Grand total from completed order API (`totals.payableAmount`). */
export function getConfirmedOrderGrandTotal(
  order: { totals?: { payableAmount?: number } } | null | undefined
): number {
  const amount = order?.totals?.payableAmount;
  return Number.isFinite(amount) ? Number(amount) : 0;
}
